export const lang = {
    page1: {
        title: ' 始于游戏，不止于游戏',
        title1: ' 释放创意，找回最初的快乐',
        des: '扫码下载 233乐园',
        goBack: "返回首页"
    },
    page2: {
        title: '极致体验',
        des: '让好游戏被更多人看到，让玩家享受到游戏之外的乐趣，233乐园一直致力于提供老少咸宜的精品游戏，任何年龄段的人都可以在游戏里收获不同的快乐，发现游戏的无限可能。',
    },
    page3: {
        title: '激发创造',
        des: '游戏的意义不仅仅在于娱乐，事实上，游戏一直在给我们的生活添加灵感，潜移默化的提升我们的生活质量，233乐园一直致力于发掘此类游戏，分享给更多的人',
    },
    page4: {
        title: '弘扬文化',
        des: '游戏是青少年最喜欢的娱乐方式，将传统文化融入其中，寓教于乐的形式更容易被接受和认同。无止境的智力游戏让你的思维敏捷，233乐园会成为最特别的老师。',
    },
    page5: {
        title: '正向价值',
        des: '233乐园一直努力探求游戏的跨界应用价值。游戏除了能够提供给人娱乐功能，也能成为文化交流，人才培养，引导健康价值观的载体。233乐园会一直为用户传递游戏正向能量。',
    },

}


// WEBPACK FOOTER //
// ./src/VueI18n/language-zh.js